import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas, listupdater } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button from '../../component/Button';
import Select from '../../component/Select';
import Radios from '../../component/Radios';
import Input from '../../component/Input';
import ListsettingPop from '../../component/ListsettingPop';
import ProductDetailPop from '../../component/ProductDetailPop';
import ProductSendPop from '../../component/ProductSendPop';
import ProductTogetherPop from '../../component/ProductTogetherPop';
import SwiperStyle1 from '../../component/SwiperStyle1';
import consts from '../../libs/consts';

import { Map, DrawingManager, MarkerClusterer, MapMarker, CustomOverlayMap } from "react-kakao-maps-sdk"
import AddrSelector from '../../component/AddrSelector';
import * as APIS from "../../utils/service";

import { getMemberinfo, numFormat, useIntersectionObserver, polygon_point_check, hpHypen } from "../../utils/utils";
import Checkbox from '../../component/Checkbox';

import queryString from 'query-string';

const { kakao } = window;

export default function ItemDetails({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    
    const query = queryString.parse(location.search);

    const { configdata } = useSelector(s => s.configReducer);
    let statusArrs = [];
    configdata?.consts?.itemStatusConsts?.map((x, i) => {
        if(x?.idx*1 === 98){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'green', 'no', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 1){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'black', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 2){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'blue', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 3){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'red', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else {
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'y', x?.idx], labels: x?.title, values: x?.idx});
        }
    });
    let category_1_setting = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return {names: x?.title, values: x?.idx}
    })
    //console.log(category_1_setting);
    let category_2_setting = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return {names: x?.title, values: x?.idx, category_1: x?.category_1}
    })

    const statusName = statusArrs;    

    const [row, setrow] = useState({}); 
    const [memos, setmemos] = useState({}); 
    const [files, setfiles] = useState([]); 
    const [desc, setdesc] = useState(''); //특이사항
    const [buttonstatus, setbuttonstatus] = useState(0); //특이사항


    const [priceinfos, setpriceinfos] = useState([
        {viewernames: '보증금', values: '5,000만원'},
        {viewernames: '월세', values: '200만원'},
        {viewernames: '관리비', values: '30만원'},
        {viewernames: '권리금', values: '5,000만원'},
        {viewernames: '실투자금', values: '10,000만원'},
    ]);   

    const [detailinfos, setdetailinfos] = useState([
        {viewernames: '매물종류', values: '상가'},
        {viewernames: '건물명', values: '골든프라자'},
        {viewernames: '해당동 총 층', values: '4층'},
        {viewernames: '층 수', values: '1층'},
        {viewernames: '계약면적', values: '100,95㎡(약 30평)'},
        {viewernames: '전용면적', values: '73,87㎡(22평)'},
        {viewernames: '방향기준/방향', values: '북/주된출입구'},
        {viewernames: '건축물용도', values: '제2종근린생활시설'},
        {viewernames: '건축물일자', values: '사용승인 20090908'},
        {viewernames: '입주가능일', values: '협의'},
    ]);   
    const [popflag, setpopflag] = useState(false); 
    const [popcomments, setpopcomments] = useState(''); 
    const [memoIdx, setmemoIdx] = useState(location?.state?.memoidx); 
    const [memostatus, setmemostatus] = useState(''); 
    const [errmsg, seterrmsg] = useState('');   
    
    useEffect(() => {
        rowDataSubmit();
    }, []);
    const rowDataSubmit = () => {

        let sender = { token: query?.itemtoken }
        console.log(sender);
        APIS.postData('/textdecrypt', sender).then(({ data }) => {
            let productIdx = data?.split('itemget=');
            //alert(productIdx);
            //alert(productIdx[1]);
            if(data){
                dispatch(loadingflas({ loading: true }));
                let sender = { idx: productIdx[1], memoidx: location?.state?.memoidx }
                console.log(sender);
                APIS.postData('/v1/item/kakaoitemget', sender).then(({ data }) => {
                    if(data){
                        console.log(data);
                        const { item, memo } = data;
        
        
                        setrow(item);
                        setmemos(memo);
                        setpopcomments(memo?.memo);
                        
                        let files = [];
                        item?.files?.map((x, i) => {
                            files.push(`${consts.s3url}/${x?.file_path}`);
                        });
                        console.log("itemitemitemitem", item);
                        setfiles(files);

                        let incomeper = ( (item?.now_price_month*12)/( (item?.price_sell*1)-(item?.now_price_all*1) ) ) * 100;
                        let investprice = 0;
                        if(item?.sell_type === '매매'){
                            investprice = (item?.price_sell*1)-(item?.now_price_all*1);
                        } else {
                            investprice = (item?.price_all*1)+(item?.price_keymoney*1);
                        }
                        setpriceinfos([
                            item?.sell_type === '매매' && {viewernames: '매매가', values: numFormat(item?.price_sell)+'만원'},
                            item?.sell_type !== '매매' && {viewernames: '보증금', values: numFormat(item?.price_all)+'만원'},
                            item?.sell_type === '월세' && {viewernames: '월세', values: numFormat(item?.price_month)+'만원'},
                            item?.sell_type === '매매' && {viewernames: '현보증금', values: numFormat(item?.now_price_all)+'만원'},
                            item?.sell_type === '매매' && {viewernames: '현월세', values: numFormat(item?.now_price_month)+'만원'},
                            item?.sell_type === '매매' && {viewernames: '수익률', values: incomeper.toFixed(1)+'%'},
                            ( (item?.sell_type === '매매' && (item?.category_2*1 === 5 || item?.category_2*1 === 6 || item?.category_2*1 === 7 || item?.category_2*1 === 8)) || 
                                    (item?.sell_type !== '매매' && (item?.category_2*1 === 5 || item?.category_2*1 === 6 || item?.category_2*1 === 7 || item?.category_2*1 === 8 || item?.category_2*1 === 9)) ) && {viewernames: '권리금', values: numFormat(item?.price_keymoney)+'만원'},
                            {viewernames: '실투자금', values: numFormat(investprice)+'만원'},
                            {viewernames: '관리비', values: numFormat(item?.price_maintenance)+'만원'},
                        ]);   
                        setdetailinfos([
                            {viewernames: '매물종류', values: category_1_setting?.find(x => x?.values*1 === item?.category_1*1)?.names},
                            {viewernames: '건물명', values: item?.title},
                            (item?.category_2*1 === 4 || item?.category_2*1 === 5 || item?.category_2*1 === 6 || item?.category_2*1 === 7 || item?.category_2*1 === 8) && {viewernames: '계약면적', values: `${item?.area_contract}㎡ (약 ${((item?.area_contract*1)/3.3057).toFixed(2)}평)`},
                            (item?.category_2*1 === 1 || item?.category_2*1 === 2 || item?.category_2*1 === 3) && {viewernames: '공급면적', values: `${item?.area_supply}㎡ (약 ${((item?.area_supply*1)/3.3057).toFixed(2)}평)`},
                            (item?.category_1*1 === 1 || item?.category_1*1 === 2) && {viewernames: '전용면적', values: `${item?.area_private}㎡ (약 ${((item?.area_private*1)/3.3057).toFixed(2)}평)`},
                            (item?.category_1*1 === 1 || item?.category_1*1 === 2) && {viewernames: '해당동', values: item?.building_dong+'층'},
                            (item?.category_1*1 === 1 || item?.category_1*1 === 2) && {viewernames: '해당동 총 층', values: item?.building_dong_floor_all+'층'},
                            (item?.category_1*1 === 1 || item?.category_1*1 === 2) && {viewernames: '해당층', values: item?.building_floor+'층'},
                            (item?.category_1*1 === 1 || item?.category_1*1 === 2) && {viewernames: '해당호', values: item?.building_floor+'호'},
                            (item?.category_1*1 === 3) && {viewernames: '토지면적', values: `${item?.area_land}㎡ (약 ${((item?.area_land*1)/3.3057).toFixed(2)}평)`},
                            (item?.category_1*1 === 3) && {viewernames: '연면적', values: `${item?.area_floor}㎡ (약 ${((item?.area_floor*1)/3.3057).toFixed(2)}평)`},
                            (item?.category_1*1 === 3) && {viewernames: '건물수', values: item?.building_count},
                            (item?.category_1*1 === 3) && {viewernames: '지상 총 층', values: item?.building_floor_all},
                            (item?.category_1*1 === 3) && {viewernames: '지하 총 층', values: item?.building_floor_under_all},
                            (item?.category_1*1 === 3) && {viewernames: '총 호수', values: item?.building_unit_all},
                            (item?.category_1*1 === 3) && {viewernames: '공실 수', values: item?.building_unit_empty},

                            {viewernames: '방향기준/방향', values: `${item?.item_direction_standard}/${item?.item_direction}`},

                            {viewernames: '방수', values: `${item?.item_room}`},
                            {viewernames: '욕실수', values: `${item?.item_bathroom}`},
                            {viewernames: '세대수', values: `${item?.item_households}`},
                            {viewernames: '총주차대수', values: `${item?.item_car_all}`},
                            {viewernames: '세대당주차', values: `${item?.item_car}`},
                            {viewernames: '해당동승강기', values: `${item?.item_elevator}`},

                            {viewernames: '건축물용도', values: item?.item_usage},
                            {viewernames: '건축물일자', values: `${item?.item_date_type}/${item?.item_date}`},
                            // window.history.length < 2 && {viewernames: '특이사항', values: `${item?.desc}`},
                            {viewernames: '매물소개', values: `${item?.itemdesc}`},
                            //{viewernames: '입주가능일', values: item?.item_move_date},
                        ]); 
                        setdesc(item?.desc);
                    }
                }).catch(({ response }) => {
                    const { data } = response;
                    console.log(data);
                }).finally(() => {
                    dispatch(loadingflas({ loading: false }));
                });   
            }
        }).catch(({ response }) => {
            const { data } = response;
            dispatch(
                open({
                    component: `잘못된 토큰정보입니다.`,
                    title: '알림',
                    titleviewer: true,
                    alert: false,
                })
            ); 
        }).finally(() => {
        });   
        
        
    }

    return(
        <>
        <div
            style={{ 
                position: 'fixed', left: 0, bottom: 0, width: '100%', padding: 10,
                display: 'flex', alignItems: 'center', justifyContent: 'center', 
                zIndex: 1003
            }}
        >
            {buttonstatus === 0 &&
            <Button 
                buttonTxt={'이 매물 어떠신가요?'} 
                className={''}
                styles={{
                    width: 250, height: 40, borderRadius: 100
                }}
                onPress={() => {
                    setbuttonstatus(1);
                }}  
            />} 
            {buttonstatus === 1 &&
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10}}>
                <Button 
                    buttonTxt={'괜찮아요'} 
                    className={''}
                    styles={{
                        width: 100, height: 40, borderRadius: 100,
                        backgroundColor: 'darkblue'
                    }}
                    onPress={() => {
                        setpopflag(true);
                        setmemostatus(0);
                    }}  
                />
                <Button 
                    buttonTxt={'별로에요'} 
                    className={''}
                    styles={{
                        width: 100, height: 40, borderRadius: 100,
                        backgroundColor: 'darkred'
                    }}
                    onPress={() => {
                        setpopflag(true);
                        setmemostatus(1);
                    }}  
                />
                <button type="button" onClick={() => { setbuttonstatus(0); }}>
                    <img src={`./images/icons/close-circle-fill.svg`} width={40} />
                </button>
            </div>}
        </div>
        <div className='ProductDetailArea'>
            <div>
                <div className='ProductDetailAreaBG' 
                    onClick={() => {
                        
                    }}
                />

                <div></div>
                <div className="ProductSendDetailpop"> 
                    <div className="ProductpopTitle padding20" style={{ position: 'relative', justifyContent: 'center' }}>
                        <Button 
                            buttonTxt={'뒤로가기'} 
                            className={'sendmemobutton'}
                            onPress={() => {
                                navigate(-1);
                            }}  
                            styles={{
                                position: 'absolute', left: 20, top: 20
                            }}
                        />  
                        <span>매물 상세</span>
                    </div>
                    <div className="ProductpopContents">
                        <div className='ProductpopContentsLeft active' style={{ width: '100%' }}>
                            {files?.length > 0 &&
                                <SwiperStyle1 
                                    listsImag={files}
                                />
                            }
                            <div className='productinfoArea1 padding20'>
                                <div className="productnumberinfos">
                                    <div className='linedotTxt'>
                                        <span>매물번호 : {row?.idx}</span>
                                        <span></span>
                                        <span>등록: {moment(row?.create_dt).format('YY.MM.DD')}</span>
                                    </div>
                                    <div>
                                        {statusArrs?.find(item => item?.idx*1 === row?.status*1)?.title}
                                    </div>
                                </div>
                                <div className="productinfos1" >
                                    <div className='linedotTxt'>
                                        <span>{category_2_setting?.find(item => item?.values*1 === row?.category_2*1)?.names}</span>
                                        <span></span>
                                        <span>{row?.sell_type}</span>
                                    </div>
                                </div>
                                {row?.sell_type === '월세' ?
                                <div className="productinfos1 styles1 bolds" >월세 {numFormat(row?.price_all)}/{numFormat(row?.price_month)}</div>
                                :
                                <div className="productinfos1 styles1 bolds" >{numFormat(row?.price_sell)}만원</div>
                                }
                                
                                <div className="productinfos1 styles2" >전용면적 {row?.area_private}㎡({((row?.area_private*1)/3.3057).toFixed(2)}평)</div>
                                <div className="productinfos1 styles3" >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 15C9.79086 15 8 13.2091 8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15Z" fill="#999999"/>
                                    </svg>                
                                    {location?.state?.position_open*1 === 3 ?
                                        <>
                                        {row?.addr}
                                        </>
                                    :
                                        <>
                                        {row?.sido} {row?.sigungu} {row?.dong}
                                        </>
                                    }                        
                                </div>
                                {/* <div className="productinfos1 styles4" >의뢰인: {row?.client_hp && hpHypen(row?.client_hp)}</div> */}
                                <div className="productinfos1 styles5" >담당자:<b>{row?.user?.name} {row?.user?.rank}</b></div>

                            </div>
                            <div className='productinfoArea2 padding20'>
                                <div>
                                    <div className="title_txt bolds">가격 정보</div>
                                    <div className='infos'>
                                        {priceinfos?.length > 0 && priceinfos?.map((x, i) => {
                                            if(!x){
                                                return;
                                            }
                                            if(row?.sell_type === '매매'){
                                                if(x?.viewernames === '보증금' || x?.viewernames === '월세'){
                                                    return;
                                                }
                                            } else {
                                                if(x?.viewernames === '매매가'){
                                                    return;
                                                }
                                            }
                                            return (
                                                <div key={i}>
                                                    <div>{x?.viewernames}</div>
                                                    <div>{x?.values}</div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                                <div>
                                    <div className="title_txt bolds">상세 정보</div>
                                    <div className='infos'>
                                        {detailinfos?.length > 0 && detailinfos?.map((x, i) => {
                                            if(!x){
                                                return;
                                            }
                                            if(row?.category_1 === 1){
                                                if(x?.viewernames === '계약면적' || x?.viewernames === '토지면적'){
                                                    return;
                                                }
                                            }
                                            if(row?.category_1 === 2){
                                                if(x?.viewernames === '공급면적' || x?.viewernames === '토지면적'){
                                                    return;
                                                }
                                            }
                                            if(row?.category_1 === 3){
                                                if(x?.viewernames === '계약면적' || x?.viewernames === '공급면적'){
                                                    return;
                                                }
                                            }

                                            const customStyle = {alignItems:"normal"}

                                            return (
                                                <div style={x?.viewernames === "매물소개" ? customStyle: {}} key={i}>
                                                    <div style={{height:"auto",minHeight: 33}}>{x?.viewernames}</div>
                                                    <div style={{height:"auto",minHeight: 33, paddingTop:8, paddingBottom:8, whiteSpace:"pre-line"}}>{x?.values}</div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                        
                </div>
                <div></div>
            </div>
        </div>

        {popflag === true &&
            <div className='PopupArea'>
                <div>
                    <div className='PopupAreaBG' 
                        //onClick={() => { setpopflag(false); }}
                    />
                    <div className='PopupAreaContents'>
                        <div>
                            <div className="popTitle padding20">
                                <span style={{ color: memostatus === 1 ? 'darkred' : 'darkblue' }} >{memostatus === 1 ? '별로에요' : '괜찮아요'}</span>
                                <button
                                    onClick={() => {
                                        setpopflag(false);
                                    }}
                                >
                                    <img src="./images/icons/x.svg" width='20' />                                            
                                </button>
                            </div>
                            <div className="padding20">
                                <div className='popcontents' style={{ flexDirection: 'column' }}>
                                    <div style={{ padding: 10 }}>
                                        이 매물을 평가한 이유를 작성해주시면, 담당자가 고객님의 <span style={{ color: '#6164A5' }}>원하는 포인트를 이해하고 더 좋은 매물을 추천하는데 도움이 됩니다.</span>
                                    </div>
                                    <div style={{ width: '100%', }}>
                                        <div style={{ width: '100%' }}>
                                            <textarea
                                                onChange={(e) => {
                                                    setpopcomments(e.target.value);
                                                }}
                                                placeholder='매물평가를 남겨주세요.'
                                                style={{
                                                    width: '100%', height: 200, padding: 12,
                                                    borderRadius: 4, border: '1px solid #DDD'
                                                }}
                                                value={popcomments}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                                {errmsg &&
                                <div className='input_error ' style={{ width: '100%', alignItems: 'center', justifyContent: 'center'}}>
                                    {errmsg}
                                </div>}
                            </div>
                            <div>
                                <Button
                                    buttonTxt={'확인'}
                                    onPress={() => { 
                                        if(popcomments === '' || popcomments === null){
                                            seterrmsg('매물을 평가하시면 담당자가 확인할 수 있으며, 고객님께 알맞는 매물을 추천하는데 매우 큰 도움이 됩니다.');
                                            return;
                                        }
                                        let sender = { idx: memoIdx, memo: popcomments, memostatus: memostatus }
                                        // console.log(sender);
                                        // return;
                                        if(memostatus*1 === 1){
                                            dispatch(
                                                open({
                                                    component: '이 매물을 목록에서 제외하시겠습니까?\n언제든 복구할 수 있습니다.',
                                                    title: '알림',
                                                    button: "확인",
                                                    buttonCencle: "취소",       
                                                    titleviewer: true,                 
                                                    alert: false,
                                                    onPress: () => {
                                                        dispatch(loadingflas({ loading: true }));
                                                        APIS.postData('/v1/customer/customersendmemoUpdate', sender).then(({ data }) => {
                                                            if(data){
                                                                //console.log(data, SendDatas);
                                                                rowDataSubmit();
                                                                setpopflag(false);
                                                                seterrmsg('');
                                                                setbuttonstatus(0);
                                                                dispatch(close());
                                                            }
                                                        }).catch(({ response }) => {
                                                            const { data } = response;
                                                            seterrmsg(data);
                                                        }).finally(() => {
                                                            dispatch(loadingflas({ loading: false }));
                                                        }); 
                                                    },
                                                    onCancelPress: () => {
                                                        dispatch(close());
                                                    }
                                                })
                                            );  
                                        } else {
                                            dispatch(loadingflas({ loading: true }));
                                            APIS.postData('/v1/customer/customersendmemoUpdate', sender).then(({ data }) => {
                                                if(data){
                                                    //console.log(data, SendDatas);
                                                    rowDataSubmit();
                                                    setpopflag(false);
                                                    seterrmsg('');
                                                    setbuttonstatus(0);
                                                }
                                            }).catch(({ response }) => {
                                                const { data } = response;
                                                seterrmsg(data);
                                            }).finally(() => {
                                                dispatch(loadingflas({ loading: false }));
                                            }); 
                                        }


                                    }}
                                    styles={{ height: 52, borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
                                />                                    
                            </div> 
                        </div>
                    </div>
                </div>

            </div>
            }
        </>
    )
}
